import { render, staticRenderFns } from "./editShopCoupon.vue?vue&type=template&id=69206f66"
import script from "./editShopCoupon.vue?vue&type=script&lang=js"
export * from "./editShopCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports